import { type FC } from "react";

const MenuOpenerIcon: FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className="size-6 text-lastbot-icon-muted"
    >
      <path d="M3 11h12a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2zm0-6h18a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2zm0 12h18a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2z" />
    </svg>
  );
};

export default MenuOpenerIcon;
